import angular from 'angular';
import { socialServiceFactory } from './socialService.factory';

export const socialServiceModule = angular
  .module('bit.services.socialService', [])
  .factory('socialService', socialServiceFactory);
